// SimplePopup.jsx
import React from "react";
import styled from "styled-components";

const PopupOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.18);
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const PopupBox = styled.div`
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.08);
  padding: 32px 30px 24px 30px;
  min-width: 300px;
  max-width: 90vw;
  text-align: center;
  font-size: 1.15em;
`;

const PopupButton = styled.button`
  margin-top: 18px;
  background: #b30000;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 10px 28px;
  font-weight: 600;
  font-size: 1em;
  cursor: pointer;
  &:hover {
    background: #990000;
  }
`;

export default function SimplePopup({ message, onClose }) {
  return (
    <PopupOverlay>
      <PopupBox>
        <div>{message}</div>
        <PopupButton onClick={onClose}>OK</PopupButton>
      </PopupBox>
    </PopupOverlay>
  );
}